// extracted by mini-css-extract-plugin
export default {"page":"PageLayout_page__Q1IG9","page__title":"PageLayout_page__title__91kE9","page__content":"PageLayout_page__content__o-l7H"};